module.exports = __webpack_public_path__ + "static/media/reg.bc0346be.svg";